import React from 'react';
import { ifCanChangeNumberFun } from '@intelligence/utils/commonUtils';
import { useIntl } from 'umi';
import TextBubblesDbi from '@/pages/intelligence/components/TextBubblesDbi';

export const WeiXinGameRender = (
  cvm: any,
) => {
  const { formatMessage } = useIntl(); // 中英切换方法

  const getGameNameTagValue = (topItem: any) => {
    if (topItem.consecutive_days > 0) {
      return {
        text: formatMessage({ id: 'dbi_wechat_top_for_day' }, { dayNum: topItem.consecutive_days }),
        type: 'yellow',
      };
    }
    if (!ifCanChangeNumberFun(topItem.rank_change)) {
      if (topItem.rank_change === '新进榜' || topItem.rank_change === 'New Entry') {
        return {
          text: formatMessage({ id: 'dbi_wechat_new_entry' }),
          type: 'blue',
        };
      }
      return null;
    }
    return null;
  };

  const gameNameTag = getGameNameTagValue(cvm);

  return (
    <div className="dbi-firstRow-top-text">
      <span className="dbi-firstRow-top-text-span">
        <TextBubblesDbi text={cvm.name} gameNameTag={gameNameTag} />
      </span>
    </div>
  );
};
